// Location: src/styles/allStyles.js
// Date: 20240929
// Author: R Matthews
// Purpose: Consolidating all styles for ease of use and provide tree shaking benefits. Use this file to import all styles in one go for single SPA apps that do not require full structure.

import { useButtonStyles } from './buttonStyles';
import { useCardStyles } from './cardStyles';
import { useFooterStyles } from './footerStyles';
import { useHeaderStyles } from './headerStyles';
import { useHeroStyles } from './heroStyles';
import { useLayoutStyles } from './layoutStyles';
import { useMiscStyles } from './miscStyles';

export { useButtonStyles, useCardStyles, useFooterStyles, useHeaderStyles, useHeroStyles, useLayoutStyles, useMiscStyles };

export const useStyles = () => ({
    ...useButtonStyles(),
    ...useCardStyles(),
    ...useFooterStyles(),
    ...useHeaderStyles(),
    ...useHeroStyles(),
    ...useLayoutStyles(),
    ...useMiscStyles()
});